import React from "react";
import PropTypes from "prop-types";

const YoutubeEmbed = ({ embedId , autoplay}) => (
  <div className="video-responsive">
    <iframe
      className="w-90 h-auto"
      src={`https://www.youtube.com/embed/${embedId}?autoplay=${autoplay}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;
